// Module
var code = "<a class=\"br-link-1 text-ellipsis\" bringoz-ppi permission permission-only=\"'shippers.get'\" permission-on-authorized=\"$root.enableElement\" permission-on-unauthorized=\"$root.disableElement\" ui-sref=\"shipper.preferences({id: $ctrl.shipper.id})\"> {{$ctrl.shipper.user | userName}} </a> ";
// Exports
export default code;